export default {
    'font': 'Font',
    'font.size': 'Font Size',
    'font.default': 'Default'
};
